<template>
    <div class="grid-content">
        <div
            class="grid-item grid-item-half"
            :class="{'grid-item-break-half': !isCustom}">
            <v-select
                label="Date Range"
                :value="selectedDateRangeName"
                :options="dateRangeOptions"
                @input="updateDateRange"/>
        </div>
        <template v-if="isCustom">
            <r-input
                class="grid-item"
                label="Previous"
                :value="customPayloadData.periodLength"
                @input="updatePeriodLength"/>
            <v-select
                label="Period"
                class="grid-item"
                :value="customPayloadData.period"
                :options="periodOptions"
                @input="updatePeriod"/>
        </template>
    </div>
</template>
<script>
    import _ from '@/common/helpers';
    import {DateRangeModel} from '@/common/models/data-export-model';
    import {vSelect} from '@/components/form';

    export default {
        name: 'date-range-form',
        components: {
            vSelect,
        },
        props: {
            validate: {
                type: Object,
                required: true,
            },
            dateRange: {
                validator: value => value === null || typeof value === 'object',
                required: true,
            },
        },
        data() {
            return {
                dateRangeOptions: Object.values(DateRangeModel.DateRanges)
                    .map(value => ({
                        value,
                        label: _.unKebabCase(value),
                    })),
                periodOptionsSource: Object.values(DateRangeModel.Periods)
                    .map(value => ({
                        value,
                        label: _.capitalize(value),
                    })),
            };
        },
        computed: {
            periodOptions() {
                return this.periodOptionsSource.map(option => ({
                    ...option,
                    label: _.pluralize(option.label, +this.customPayloadData.periodLength),
                }));
            },
            selectedDateRangeName() {
                return DateRangeModel.parsePayloadName(this.dateRange || undefined);
            },
            isCustom() {
                return this.selectedDateRangeName === DateRangeModel.DateRanges.custom;
            },
            customPayloadData() {
                if (!this.isCustom) {
                    return {
                        periodLength: '',
                        period: '',
                    };
                }
                return DateRangeModel.parseCustomPayload({start: this.dateRange.start});
            },
        },
        methods: {
            updateDateRange(name) {
                this.$emit('update', DateRangeModel.makePayLoad({name}));
            },
            updatePeriod(period) {
                this.$emit('update', DateRangeModel.makePayLoad({
                    name: this.selectedDateRangeName,
                    periodLength: this.customPayloadData.periodLength,
                    period,
                }));
            },
            updatePeriodLength(periodLength) {
                this.$emit('update', DateRangeModel.makePayLoad({
                    name: this.selectedDateRangeName,
                    periodLength,
                    period: this.customPayloadData.period,
                }));
            },
        },
    };
</script>
